// Login button that appears on the LoginWithGoogleModal

import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const GoogleLoginButton = ({ rememberMe = false, disabled = false }) => {
  const { isAuthenticated } = useAuth();

  /**
   * Handles the login process by redirecting to the Google authorization URL.
   * If an access token already exists in local storage, do nothing.
   * Otherwise, redirect to the authorization URL with the required parameters.
   */
  function handleLogin() {
    if (disabled) {
      return;
    }
    if (isAuthenticated) {
      console.log('Already authenticated');
      return;
    }

    // Store remember me preference for OAuth callback
    if (rememberMe) {
      localStorage.setItem('googleOAuthRememberMe', 'true');
    } else {
      localStorage.removeItem('googleOAuthRememberMe');
    }

    const clientId = CLIENT_ID;
    const redirectUri = encodeURIComponent(process.env.REACT_APP_REDIRECT_URI);
    // Only request basic profile scopes for login
    const scope = encodeURIComponent(
      'openid https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email'
    );
    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&access_type=offline&prompt=consent`;
    window.location.href = authUrl;
  }

  return (
    <button
      onClick={handleLogin}
      disabled={disabled}
      className={`w-full py-2.5 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-gray-300 bg-white text-sm font-medium text-gray-700 shadow-xs focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-50'}`}
    >
      <svg className="w-5 h-5" viewBox="0 0 24 24">
        <path
          d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
          fill="#4285F4"
        />
        <path
          d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
          fill="#34A853"
        />
        <path
          d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
          fill="#FBBC05"
        />
        <path
          d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
          fill="#EA4335"
        />
      </svg>
      Continue with Google
    </button>
  );
};

export default GoogleLoginButton;
